export default "__VITE_ASSET__Aqru0F9J__"